import React from 'react';
import {useField} from 'formik';
import {ReactDatePickerProps} from 'react-datepicker';
import InputDateRange from '../../../../common/components/ui/InputDateRange';
import styles from './FieldDateRange.module.scss';

const FieldDateRange = () => {
  const [
    fieldFromDate,,
    helpersFromDate
  ] = useField({name: 'fromDate'});
  const [
    fieldToDate,,
    helpersToDate
  ] = useField({name: 'toDate'});

  const handleChange: ReactDatePickerProps<any, true>['onChange'] = ([fromDate, toDate]) => {
    helpersFromDate.setValue(fromDate);
    helpersToDate.setValue(toDate);
  };

  const handleReset = () => {
    helpersFromDate.setValue(null);
    helpersToDate.setValue(null);
  };

  return (
    <div className={styles.fieldDateRangeContainer}>
      <InputDateRange
        onChange={handleChange}
        startDate={fieldFromDate.value}
        endDate={fieldToDate.value}
        onReset={handleReset}
      />
    </div>
  );
};

export default FieldDateRange;
